module.exports = __webpack_public_path__ + "static/media/HomePageSubitise_72dpi.ea15c5bd.png";